import { styled } from 'baseui'

export const ResultCard = styled('article', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
  paddingTop: '1rem',
  paddingBottom: '1rem',
  paddingLeft: '1rem',
  paddingRight: '1rem',
  backgroundColor: $theme.colors.white,
  border: `1px solid ${$theme.colors.borderPulseCard}`,
  borderRadius: '0.75rem',
}))

export const ResultHeader = styled('header', {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: '0.75rem',
})

export const ResultTitle = styled('h3', ({ $theme }) => ({
  marginTop: 0,
  marginBottom: '0.25rem',
  fontSize: '0.9375rem',
  lineHeight: '1.35',
  fontWeight: 600,
  color: $theme.colors.textPulseStrong,
}))

export const ResultSummary = styled('span', ({ $theme }) => ({
  fontSize: '0.75rem',
  color: $theme.colors.textPulseMuted,
}))

export const StatusChip = styled<'span', { $open: boolean }>('span', ({ $theme, $open }) => ({
  flexShrink: 0,
  paddingTop: '0.125rem',
  paddingBottom: '0.125rem',
  paddingLeft: '0.5rem',
  paddingRight: '0.5rem',
  fontSize: '0.6875rem',
  fontWeight: 600,
  borderRadius: '999px',
  color: $open ? $theme.colors.chipOkText : $theme.colors.textPulseChipNeutral,
  backgroundColor: $open ? $theme.colors.chipOkBg : $theme.colors.chipNeutralBg,
}))

export const ResultBody = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '1.5rem',
})

export const VotersToggle = styled('button', ({ $theme }) => ({
  alignSelf: 'flex-start',
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
  fontSize: '0.75rem',
  fontWeight: 600,
  color: $theme.colors.primaryPulse,
  backgroundColor: 'transparent',
  border: 0,
  cursor: 'pointer',
  ':hover': { textDecoration: 'underline' },
  ':focus-visible': { outline: 'none', boxShadow: `0 0 0 0.1875rem ${$theme.colors.accent}` },
}))
